export { default } from "./EditUserFields";



// WEBPACK FOOTER //
// ./src/components/UserDetails/EditUserFields/index.ts